import { Masonry } from "./Masonry.component";

export default Masonry;
